import styled from 'styled-components'

const Accordion = styled.div`
  .deal {
    border: 1px solid ${props => props.theme.color.monochrome.light};
    border-radius: 10px;
    margin: 10px 0;
    min-height: 150px;

    &__details {
      padding: 20px;
      display: flex;
      flex-wrap: wrap;
    }

    &__summary {
      background-color: ${props => props.theme.color.monochrome.lighter};
      display: flex;
      flex-direction: column;
      padding: 20px;
      border-radius: 0 10px 10px 0;
      justify-content: flex-end;
      text-align: center;
      align-items: center;

      @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
        border-radius: 0 0 10px 10px;
      }
    }
  }
`

const Header = styled.div`
  display: flex;
  color: ${props => props.theme.color.palette['brand-1']};
  margin-right: 25px;
  align-items: center;
`

const Title = styled.span`
  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    width: 175px;
  }
`

export { Accordion, Header, Title }
